const definitionLists = document.querySelectorAll('.opnews__definition-list');

if (definitionLists && definitionLists.length > 0) {
    addBreaks();
}

function addBreaks () {
    definitionLists.forEach(list => {
        list.querySelectorAll('div').forEach((div, index) => {
            if ((index + 1) % 2 === 0) {
                const breakDiv = document.createElement('div');
                breakDiv.className = 'break';
                div.after(breakDiv);
            }
        });
    });
}
